@if (isLoading) {
<mat-progress-bar
        color="primary"
        mode="indeterminate">
</mat-progress-bar>
}

<div class="max-height">
    <section class="ap-p-spacing-6">
        <div class="ap-p-spacing-6">
            <table class="table table-hover table-bordered table-striped table-condensed">
                <thead class="a-thead">
                    <tr>
                        <th>Source System</th>
                        <th>LEID</th>
                        <th>Tax Code</th>
                        <th>Reporting Period</th>
                        <th>ME Code</th>
                        <th>Currency</th>
                        <th>Ledger</th>
                        <th>Current Chart Code</th>
                        <th>Transactions to be Deleted</th> <!-- Delete Transaction -->
                        <th>Trans details Dropdown with Count</th>
                        <th>Update Chart Code</th> <!-- Update Chart Code -->
                       
                    </tr>
                </thead>
                @if (allEntityDetails.length > 0) {
<tbody class="a-tbody tbody-regular tbody-hover">
                    @for (entity of allEntityDetails; track $index; let i = $index) {

                        @for (item of entity.groupItems; track $index; let j = $index) {
<tr>
                            <td>
                                @if (j == 0) {

                                    {{item.source_SYSTEM_FLAG =='D'? 'Domestic' : 'Foreign'}}
                                
}
                            </td>
                            <td class="width-entity">
                                @if (j == 0) {

                                    {{entity.leid}}
                                
}
                            </td>
                            <td>{{item.cdr_NO}}</td>
                            <td>{{item.reporting_PERIOD}}</td>
                            <td>{{entity.me_CODE}}</td>
                            <td>{{item.curr}}</td>
                            <td>{{item.ledger}}</td>
                            <td>{{allEntityDetails_backup[i]['chart_CODE']}}</td>
                            <td>
                                <!-- <mat-checkbox class="font-black-color" [(ngModel)]="item.selection" 
                                    *ngIf="j == 0" [disabled]="item.selection"
                                    (click)='checkboxClicked(entity,i,j )'></mat-checkbox> -->
                                <div>
                                    {{item.trans_COUNT}}
                                    @if (item.selection && item.trans_COUNT > 0) {
<span class='delete-msg' >{{deleteLabel}}</span>
}
                                    @if (item.selection && j == 0) {
<button class='btn btn-warning btn-sm' aria-label="clear selection" (click)='clearButtonClicked($event,entity,i,j); item.selection= false;'>
                                        Cancel
                                    </button>
}
                                </div>
                                <!-- <span  style="padding-left: 35px;" *ngIf="j != 0">
                                    {{item.trans_COUNT}}
                                </span> -->
                            </td>
                            <td>
                                <!-- [(ngModel)]=""  -->
                                @if (item.trans_COUNT != 0) {
<mat-select name="transCount">
                                    @for (count of optionsTransCount; track $index) {

                                        @if (item.combination_KEY == count.COMBINATION_KEY) {
<mat-option   [value]="count.TRANS_TYPE_KEY"> 
                                            {{count.TRANS_DETAILS}}
                                        </mat-option>
}
                                    
}
                                </mat-select>
}
                                @if (item.trans_COUNT == 0) {

                                    No transactions to Delete
                                
}
                            </td>
                         
                            @if (j == 0) {
<td [attr.rowspan]="item.col_SPAN"  style="vertical-align: middle;">
                                <ng-container >
                                    <mat-form-field class="font-black-color" style="margin-top: 5px;">
                                        <mat-label class="font-black-color">Chart Code</mat-label>
                                        <input type="text" class="font-black-color"
                                            placeholder="Filter Chart Code"
                                            aria-label="Enter chart code"
                                            (focus)="backupEntity(entity,i,j)"                                        
                                            matInput
                                            [formControl]="allEntitiesChartCodeFormControls[i]"
                                            [matAutocomplete]="auto">
                                        <mat-autocomplete class="" #auto="matAutocomplete" (optionSelected)="selectedOption($event.option)" [displayWith]="displayFn">
                                            <mat-optgroup [label]="'Preferred'" >
                                                @for (option of allFilteredOptions[i] | async; track $index) {

                                                    @if (option.chart_type == entity.entity_TYPE) {
<mat-option class="" [value]="option">
                                                        {{option.code}}
                                                    </mat-option>
}
                                                
}
                                            </mat-optgroup>
                                            <mat-optgroup [label]="'Non Preferred'" ></mat-optgroup>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </ng-container>
                                <!-- <ng-container *ngIf="j != 0">
                                    {{allEntitiesChartCodeFormControls[i].value.code}}
                                </ng-container> -->
                            </td>
}
                      
                        </tr>
}
                    
}    
                </tbody>
}
                @if (allEntityDetails.length == 0 && !isLoading) {
<tbody class="a-tbody tbody-regular tbody-hover">
                    <tr>
                        <td colspan="11" class="text-sm-center">No Record</td>
                    </tr>
                </tbody>
}
            </table>
        </div>
    </section>
</div>


<div  class="row">
    <div class="col-md-9"></div>
    <div class="col-md-3">
        <ap-button [label]="'Save'" class="ap-mr-spacing-3" 
            [btnType]="'primary'" 
            (onClick)="openDialog(onSaveHeader, onSave, type.save)"></ap-button>
        <ap-button [label]="'Cancel'" class="ap-mr-spacing-3" 
            [btnType]="'primary'" 
            (onClick)="modalClose()">
        </ap-button>
        <!-- <button mat-flat-button color="primary" aria-label="Save" (click)="openDialog(onSaveHeader, onSave, type.save)">Save</button>
        <button mat-flat-button color="warn" aria-label="Close" (click)='modalClose()' style='margin-left: 10px;'>Cancel</button> -->
    </div>
</div>





